import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=77727eff&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77727eff')) {
      api.createRecord('77727eff', component.options)
    } else {
      api.reload('77727eff', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=77727eff&", function () {
      api.rerender('77727eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XIXAN5488smZ/JS/cancellationPolicy.vue"
export default component.exports